export enum MONTH_FORMAT {
  MONTH_FORMAT_DE = 'MM.YYYY',
  MONTH_FORMAT_US = 'MM/YYYY',
  MONTH_FORMAT_VN = 'MM.YYYY',
  MONTH_FORMAT_BACKEND = 'YYYY-MM',
}
